import { useContext, useEffect, useRef } from 'react';
import { AppContext } from '@/core/context/AppContext';
import { identifyUser, ReportType, trackReportViewed } from './posthog';

export interface TrackedReport {
  id: string;
  name: string;
  url: string;
  type: ReportType;
}

export const useTrackReportViewed = (report: TrackedReport | undefined) => {
  const { userData, buOfUser, buLoaded } = useContext(AppContext);
  const trackedReportId = useRef('');
  const userId = userData?.id;

  useEffect(() => {
    if (!report) {
      trackedReportId.current = '';
      return;
    }
    if (!userId || !buLoaded || trackedReportId.current === report.id) {
      return;
    }

    trackedReportId.current = report.id;
    identifyUser(userId, { businessUnits: buOfUser });
    trackReportViewed({
      report_id: report.id,
      report_name: report.name,
      report_url: report.url,
      report_type: report.type,
      business_units: buOfUser,
    });
  }, [report?.id, report?.type, userId, buLoaded]);
};
